<template>
    <div v-if="shouldShow" class="mb-3 pb-1 mt-0">
        <!-- Alert -->
        <div class="alert alert-danger">
            <div class="alert-inner">
                <div class="left">
                    <b>{{ incompleteTasks.length }} incomplete unassigned {{ incompleteTasks.length == 1 ? 'task' : 'tasks' }}</b>
                </div>
                <div class="right">
                    <a href="#" class="btn btn-itg btn-sm" v-b-modal.incomplete-tasks-modal>
                        View Tasks
                    </a>
                </div>
            </div>
        </div>
        <!-- / Alert -->

        <!-- Modal -->
        <b-modal size="lg" hide-footer id="incomplete-tasks-modal" title="Incomplete Tasks">
            <!-- Loading -->
            <div v-if="isLoading" class="text-center">
                <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>
            <!-- / Loading -->

            <!-- No tasks -->
            <div v-if="!isLoading && incompleteTasks.length === 0" class="alert alert-success border-0 mb-0">
                No incomplete tasks!
            </div>
            <!-- / No tasks -->

            <!-- Table -->
            <div class="table-responsive mb-0" v-if="!isLoading && incompleteTasks && incompleteTasks.length">
                <table class="table mb-0 table-centered">
                    <thead class="thead-light">
                        <tr>
                            <th>Task</th>
                            <th>Due Date</th>
                            <th>Ticket</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="task in incompleteTasks" :key="`task-${task.id}`">
                            <td>
                                {{ task.description }}
                            </td>
                            <td>
                                {{ task.deadline ? displayTimestamp(task.deadline) : '-' }}
                            </td>
                            <td>
                                {{ task.ticket.subject }}
                            </td>
                            <td class="text-right">
                                <router-link :to="`/tickets/${task.ticket.id}`" class="btn btn-sm btn-itg">
                                    View Ticket
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- / Table -->
        </b-modal>
        <!-- / Modal -->
    </div>
</template>

<script>
import axios from 'axios';
import Dates from '../../mixins/Dates';

export default {
    data() {
        return {
            incompleteTasks: [],
            isLoading: false
        }
    },

    mixins: [Dates],

    created() {
        this.incompleteTasks = [];
        if (window.itgShouldLoadIncompleteTasks) {
            this.loadIncompleteTasks();
        }
    },

    methods: {
        loadIncompleteTasks() {
            let vm = this;
            vm.isLoading = true;
            axios.get(window.API_BASE + '/incomplete-unassigned-tasks')
                .then(function (response) {
                    vm.incompleteTasks = response.data;
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    vm.isLoading = false;
                });
        }
    },

    computed: {
        shouldShow() {
            return window.itgShouldLoadIncompleteTasks && this.incompleteTasks.length;
        }
    }
}
</script>

<style scoped lang="scss">
.alert-inner {
    display: flex;
    width: 100%;
    height: 100%;

    .left {
        flex-grow: 1;
        display: flex;
        align-items: center;

        b {
            font-weight: 600;
        }
    }

    .right {
        flex-shrink: 1;
        display: flex;
        align-items: center;
    }
}
</style>